import { IDateCicloChurn } from "@/pages/cobrancasaldochurn/cobrancasaldochurn/modal/dateSelect";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class FaturaSaldoChurnService {
    async generate(values: IDateCicloChurn) {
        return await api.post<any>(`${resources.faturaSaldoChurn}/Generate`, values);
    }

    async update(data: any) {
        return await api.put(`${resources.faturaSaldoChurn}/Update`, data);
    }

    async approve(id: any) {
        return await api.put<any>(`${resources.faturaSaldoChurn}/Approve/${id}`);
    }

    async reopen(data: any) {
        return await api.put<any>(`${resources.faturaSaldoChurn}/Reopen/${ToQueryString(data)}`);
    }

    async discard(id: any) {
        return await api.put<any>(`${resources.faturaSaldoChurn}/Discard/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaSaldoChurn}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async approveMany(data: any) {
        return await api.post<any>(`${resources.faturaSaldoChurn}/ApproveMany`, data);
    }

    async publish(data: any) {
        return await api.post<any>(`${resources.faturaSaldoChurn}/Publish`, data);
    }

    async recalculate(id: any) {
        return await api.post<any>(`${resources.faturaSaldoChurn.toLowerCase()}/recalculate/${id}`);
    }

    async getListaErros(filters: any) {
        return await api.get(`${resources.faturaSaldoChurn}/GetListaErros/${ToQueryString(filters)}`);
    }
}

export default new FaturaSaldoChurnService();
